import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DynamicSubjectService {
  getValues: BehaviorSubject<any> = new BehaviorSubject('');
  handleGetValues(val: boolean) {
    this.getValues.next(val);
  }
}
